module.exports = __webpack_public_path__ + "img/somoy-logo.c5c53b7b.png";